import React from 'react';
import moment from "moment";
import Link from '../base/Link';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from '../base/SorTable';
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class Weaves extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_weaves: "/weave/fetch/all?limit_from=:from&limit_max=:to&withForms=:withForms&brand=:brand",
			delete_weave: "/weave/delete/:weave"
		});

		this.state = {
			weaves: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 16 },
				{ name: "form", display: translate("Dotazník"), sort: true, width: 16 },
				{ name: "protocol", display: translate("Protokol"), sort: true, width: 16 },
				{ name: "client", display: translate("Klient"), sort: true, width: 19 },
				{ name: "brand", display: translate("Značka"), sort: true, width: 10 },
				{ name: "date_from", display: translate("Od"), sort: true, width: 9 },
				{ name: "date_to", display: translate("Do"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (weave) {
			weave.name = <Link to={"/weaves/edit/" + weave.id} textIfNoAccess={true} permission="WeaveEdit">{weave.name}</Link>
			weave.client = weave.client;
			weave.form = typeof weave.form !== "undefined" ? weave.form.name : "---";
			weave.protocol = typeof weave.protocol !== "undefined" ? weave.protocol.name : "---";
			weave.date_from = moment(weave.date_from.date).format("D.M.Y");
			weave.date_to = moment(weave.date_to.date).format("D.M.Y");
			weave.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteWeave.bind({ weave: weave.id, currentComponent: this })} permission="WeaveNew" />
				</div>
			);
			return weave;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");
		this.api.request({
			cache: true,
			route: "get_weaves",
			params: { from: 0, to: 99999, withForms: true, brand: brandFilter ? brandFilter.id : "all" },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ weaves: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteWeave(evt) {
		this.currentComponent.api.request({
			route: "delete_weave",
			params: { "weave": this.weave },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Vlny")} right={() => {
				if (Storage.get("allowed_components").indexOf("WeaveNew") === -1) {
					return "";
				}
				return (
					<Link to="/weaves/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/weave/Weaves.js